// src/trade-drives/index.js — Trade Drives module entry point
//
// This file is the bundler entry. esbuild reads from here and follows
// imports to produce dist/trade-drives.js as an IIFE bundle with global
// name `TradeDrives`. The HTML loads that bundle and the inline onclick
// handlers call TradeDrives.setPeriod(...), TradeDrives.setChart(...),
// TradeDrives.onTabOpen() etc.
//
// Single-namespace flat re-export (TradeDrives has no sub-modules,
// unlike Top50 which has admin/staff/shared). Matches the existing
// inline call-site shape — no HTML changes required.

export * from './trade-drives.js';
